<template>
  <router-view />
</template>

<style>
@import '../../../../node_modules/compensatory-service/scss/style.scss';
</style>
<script>
import storeMixin, { unRegisterMixin } from '@/mixin/storeGenerator';
const STORE_MODULE_NAME = 'CompensatoryServiceModule';

export default {
  name: 'CompensatoryWrapper',
  mixins: [unRegisterMixin, storeMixin],
  data: () => ({
    moduleName: STORE_MODULE_NAME,
  }),
};
</script>
